export default __webpack_public_path__ + "static/media/right-arrow.747c24d4.svg";